const STORAGE_KEY = "rpgcoin_notified_sold";

export const getNotifiedIds = (): string[] => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
};

export const isNotified = (id: string): boolean => getNotifiedIds().includes(id);

export const markNotified = (id: string): void => {
  const ids = getNotifiedIds();
  if (!ids.includes(id)) {
    ids.push(id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }
};
